import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import IdleTimer from "react-idle-timer";

import Header from "../../components/Header/";
import Sidebar from "../../components/Sidebar/";
import Dashboard from "../../views/Dashboard/";

import ShortcutsBar from "../../components/ShortcutsBar/ShortcutsBar";

import Usuarios from "../../views/Usuarios/Usuarios/";
import Permisos from "../../views/Usuarios/Permisos/";
import Grupos from "../../views/Usuarios/Grupos/";
import Ventas from "../../views/Ventas/Ventas";
import Cobros from "../../views/Cobros/Cobros";
import Consultas from "../../views/Consultas/Consultas";
import Reservas from "../../views/Reservas/Reservas";
import EstadoGralDeudas from "../../views/Consultas/EstadoGral/Deudas";
import CuotasPagas from "../../views/CuotasPagas/CuotasPagas";

import CuotasPagasEs from "../../views/CuotasPagasEs/CuotasPagasEs";
import CuotasPagasSe from "../../views/CuotasPagasSe/CuotasPagasSe";

import TipoEventos from '../../views/TipoEventos/TipoEventos';

import TiposDeDocumento from '../../views/Configuracion/TiposDeDocumento/';
import TiposDeComprobante from '../../views/Configuracion/TiposDeComprobante/';
import Rubros from '../../views/Configuracion/Rubros/';
import Encabezados from '../../views/Configuracion/Encabezados/';
import EstadoCivil from '../../views/Configuracion/EstadoCivil/';
import Localidades from '../../views/Geograficas/Localidades/';
import Provincias from '../../views/Geograficas/Provincias/';
import Nacionalidades from '../../views/Geograficas/Nacionalidades/';
import Sucursales from '../../views/Geograficas/Sucursales/';

import Proveedores from '../../views/Proveedores/';
import Obras from '../../views/Obras/Obras/';
import Gastos from '../../views/Obras/Gastos/';
import Clientes from '../../views/Clientes/Clientes';
import Loteos from '../../views/Loteos/Loteos';
import Plantillas from '../../views/Configuracion/Mails/Plantillas';
import Casillas from '../../views/Configuracion/Mails/Casillas';
import Bitacora from '../../views/Configuracion/Mails/Vitacora/Bitacora.js';
import Vendedores from '../../views/Vendedores/Vendedores';
import EscribaniaList from '../../views/Escribania/EscribaniaList';
import MiCalendario from '../../views/Calendar/MiCalendario';

import ActualizarValores from '../../views/Cuotas/ActualizarValores/ActualizarValores.js';
import AjustarDesactualizadas from '../../views/Cuotas/AjustarDesactualizadas/AjustarDesactualizadas.js';

import Caja from '../../views/Caja/Caja';
import MovimientosCaja from '../../views/Caja/MovimientosCaja/MovimientosCaja';
import MovimientosCajaCuentas from '../../views/Caja/MovimientosCajaCuentas/MovimientosCajaCuentas';
import Cuentas from '../../views/Caja/Cuentas';
import MovimientosAgrupados from '../../views/Caja/MovimientosAgrupados/MovimientosAgrupados';

import Monedas from '../../views/Monedas/Monedas/Monedas.js';
import HistorialMonedas from '../../views/Monedas/Historial/HistorialMonedas.js';

import Firmas from '../../views/Recibos/Firmas/Firmas.js';

import Reportes from '../../views/Reportes/Reportes';


import auth from "../../auth/auth";
import api from "../../api/api";

import Servicios from "../../views/Servicios/Servicios/Servicios.js";
import CobrosServicios from "../../views/Servicios/Cobros/Cobros.js";
import ServiciosDeudas from "../../views/Servicios/EstadoGral/Deudas.js"

import Escrituras from "../../views/Escrituras/Escrituras/Escrituras.js";
import CobrosEscrituras from "../../views/Escrituras/Cobros/Cobros.js";
import EscriturasDeudas from "../../views/Escrituras/EstadoGral/Deudas.js";
import Inversionistas from "../../views/Inversionistas/Configuracion/Inversionistas";
import Resumen from "../../views/Inversionistas/Resumen/Resumen";
import TableCambiosVencimiento from "../../views/Configuracion/CambiarVencimiento/TableCambiosVencimiento";

class Full extends Component {
	constructor(props) {
		super(props);
		this.state = {
			idle: false
		};
		this.idleTimer = null;
	}

	onIdle = e => {
		auth.logout();
		this.setState(() => ({
			idle: true
		}));
	};

	render() {
		if (this.state.idle) return <Redirect to="/locked" />;

		return (
			<div className="app">
				<IdleTimer
					ref={ref => { this.idlerTimer = ref; }}
					element={document}
					onIdle={this.onIdle}
					timeout={99999 * 60 * 30}
				>
					<Header />
					<div className="app-body">
						<Sidebar {...this.props} />
						<main className="main">
							<Container fluid>
								<Switch>
									<Route path="/dashboard" name="Dashboard" component={Dashboard} />

									<Route path="/usuarios/usuarios" name="Usuarios" component={Usuarios} />
									<Route path="/usuarios/permisos" name="Permisos" component={Permisos} />
									<Route path="/usuarios/grupos" name="Grupos" component={Grupos} />

									<Route path="/usuarios/usuarios" name="Usuarios" component={Usuarios} />
									<Route path="/usuarios/permisos" name="Permisos" component={Permisos} />
									<Route path="/usuarios/grupos" name="Grupos" component={Grupos} />
									<Route path="/configuracion/tipoeventos/" name="TipoEventos" component={TipoEventos} />
									<Route path="/configuracion/tiposdedocumento" name="TiposDeDocumento" component={TiposDeDocumento} />
									<Route path="/configuracion/tiposdecomprobante" name="TiposDeComprobante" component={TiposDeComprobante} />
									<Route path="/configuracion/rubros" name="Rubros" component={Rubros} />
									<Route path="/configuracion/registro" name="Registro" component={TableCambiosVencimiento} />
									<Route path="/configuracion/encabezados" name="Encabezados" component={Encabezados} />
									<Route path="/configuracion/estadocivil" name="EstadoCivil" component={EstadoCivil} />
									<Route path='/geograficas/localidades' name="Localidades" component={Localidades} />
									<Route path='/geograficas/provincias' name="Provincias" component={Provincias} />
									<Route path='/geograficas/nacionalidades' name="Nacionalidades" component={Nacionalidades} />
									<Route path='/geograficas/sucursales' name="Sucursales" component={Sucursales} />

									<Route path='/proveedores' name="Proveedores" component={Proveedores} />
									<Route path='/obras/obras' name="Obras" component={Obras} />
									<Route path='/obras/gastos' name="Gastos" component={Gastos} />

									<Route path='/mails/bitacora' name="Bitacora" component={Bitacora} />

									<Route path="/calendario" name="MiCalendario" component={MiCalendario} />

									<Route path="/inversionistas/inversionistas" name="Inversionistas" component={Inversionistas}/>
									<Route path="/inversionistas/resumen" name="Resumen" component={Resumen}/>
									<Route path="/vendedores/vendedores" name="Vendedores" component={Vendedores} />

									<Route path="/clientes" name="Clientes" component={Clientes} />
									<Route path="/consultas/estadograldeudas" name="EstadoGralDeudas" component={EstadoGralDeudas} />
									<Route path="/consultas" name="Consultas" component={Consultas} />
									<Route path="/reservas" name="Reservas" component={Reservas} />

									<Route path="/cuotaspagas" name="CuotasPagas" component={CuotasPagas} />
									<Route path="/cuotaspagases" name="CuotasPagasEs" component={CuotasPagasEs} />
									<Route path="/cuotaspagasse" name="CuotasPagasSe" component={CuotasPagasSe} />

									<Route path="/ventas" name="Ventas" component={Ventas} />
									<Route path="/cobros" name="Cobros" component={Cobros} />

									<Route path="/loteos" name="Loteos" component={Loteos} />

									<Route path="/escribanialist" name="EscribaniaList" component={EscribaniaList} />
                                    
                                    <Route path="/cuotas/ajustar-desactualizadas" name="AjustarDesactualizadas" component={AjustarDesactualizadas} />
									<Route path="/cuotas/actualizar-valores" name="ActualizarValores" component={ActualizarValores} />

									<Route path="/caja" name="Caja" component={Caja} />
									<Route path="/movimientoscaja" name="MovimientosCaja" component={MovimientosCaja} />
									<Route path="/movimientoscajacuentas" name="MovimientosCajaCuentas" component={MovimientosCajaCuentas} />
									<Route path="/cuentas" name="Cuentas" component={Cuentas} />
									<Route path="/movimientosagrupados" name="MovimientosAgrupados" component={MovimientosAgrupados} />

									<Route path="/monedas/monedas" name="Monedas" component={Monedas} />
									<Route path="/monedas/historial" name="HistorialMonedas" component={HistorialMonedas} />

									<Route path="/recibos/firmas" name="Firmas" component={Firmas} />

									<Route path="/reportes" name="Reportes" component={Reportes} />

									<Route path="/configuracion/mails/casillas" name="Casillas" component={Casillas} />
									<Route path="/configuracion/mails/plantillas" name="Plantillas" component={Plantillas} />

									<Route path="/servicios/servicios" name="Servicios" component={Servicios} />
									<Route path="/servicios/cobros" name="CobrosServicios" component={CobrosServicios} />
									<Route path="/servicios/deudas" name="ServiciosDeudas" component={ServiciosDeudas} />

									<Route path="/escrituras/escrituras" name="Escrituras" component={Escrituras} />
									<Route path="/escrituras/cobros" name="CobrosEscrituras" component={CobrosEscrituras} />
									<Route path="/escrituras/deudas" name="EscriturasDeudas" component={EscriturasDeudas} />

									<Redirect from="/" to="/dashboard" />
								</Switch>
							</Container>
						</main>
					</div>
					<ShortcutsBar url={api.usuarios.perfil} />
				</IdleTimer>
			</div>
		);
	}
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js